import React, { useEffect, useState } from 'react';
import { Row, Col, Container, Spinner } from 'react-bootstrap';
import Card from '../../../components/Card';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { getToken } from '../../../utils/auth';

const UserAnnouncement = () => {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const { t, i18n } = useTranslation();

    const handleAllAnnouncement = async () => {
        try {
            const token = getToken();
            const response = await axios.get(
                `${process.env.REACT_APP_URL}/api/announcement/active`,
                {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                    }
                }
            );
            setData(response?.data?.data?.announcementList);
        } catch (error) {
            console.log("Failed Fetching announcement", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        handleAllAnnouncement();
    }, []);

    return (
        <>
            <Container className='p-2'>
                <Row>
                    <Col lg="12">
                        <Card>
                            <Card.Header className="d-flex justify-content-between">
                                <div className="header-title">
                                    <h4 className="card-title">{t('announcement_title')}</h4>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <div className="acc-privacy">
                                    {isLoading ? (
                                        <div className="text-center">
                                            <Spinner animation="border" role="status">
                                                <span className="visually-hidden">{t('query_loading')}</span>
                                            </Spinner>
                                        </div>
                                    ) : data.length === 0 ? (
                                        <p className="text-center">{t('announcement_no_available')}</p>
                                    ) : (
                                        data.map((announcement, index) => (
                                            <React.Fragment key={index}>
                                                <div className="data-privacy">
                                                    <p dangerouslySetInnerHTML={{ __html: announcement?.content }}></p>
                                                </div>
                                                <hr />
                                            </React.Fragment>
                                        ))
                                    )}
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default UserAnnouncement;
